import i18n from "@/i18n";
import { useMainStore } from "@/store/main.store";
import { defaultOptions, usePrimeVue } from "primevue/config";
import dayjs from "dayjs";

export const setLocale = (locale: { locale: "en" | "ca" | "es" | "it"; code: string; name: string }, primevue?: any) => {
  const mainStore = useMainStore();
  mainStore.preferedLanguage = locale;
  i18n.global.locale = locale.locale;
  setPrimeVueLocale(primevue);
  dayjs.locale(locale.locale);
};
const setPrimeVueLocale = (primevue?: any) => {
  const $primevue = primevue || usePrimeVue();
  const { t } = i18n.global;
  const primeVueLocalization = {
    startsWith: t("Starts with"),
    contains: t("Contains"),
    notContains: t("Not contains"),
    endsWith: t("Ends with"),
    equals: t("Equals"),
    notEquals: t("Not equals"),
    noFilter: t("No Filter"),
    lt: t("Less than"),
    lte: t("Less than or equal to"),
    gt: t("Greater than"),
    gte: t("Greater than or equal to"),
    dateIs: t("Date is"),
    dateIsNot: t("Date is not"),
    dateBefore: t("Date is before"),
    dateAfter: t("Date is after"),
    clear: t("Clear"),
    apply: t("Apply"),
    matchAll: t("Match All"),
    matchAny: t("Match Any"),
    dayNamesMin: [t("Su"), t("Mo"), t("Tu"), t("We"), t("Th"), t("Fr"), t("Sa")],
    monthNames: [t("January"), t("February"), t("March"), t("April"), t("May"), t("June"), t("July"), t("August"), t("September"), t("October"), t("November"), t("December")],
    emptyMessage: t("no-available-options"),
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: [t("Sunday"), t("Monday"), t("Tuesday"), t("Wednesday"), t("Thursday"), t("Friday"), t("Saturday")],
    dayNamesShort: [t("Sun"), t("Mon"), t("Tue"), t("Wed"), t("Thu"), t("Fri"), t("Sat")],
    monthNamesShort: [t("Jan"), t("Feb"), t("Mar"), t("Apr"), t("May"), t("Jun"), t("Jul"), t("Aug"), t("Sep"), t("Oct"), t("Nov"), t("Dec")],
  };
  $primevue.config.locale = {
    ...(defaultOptions.locale || []), // use default values for everything else
    firstDayOfWeek: 1, // change to Monday
    ...primeVueLocalization,
  };
};
